import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import '../ConsentWithdrawal/ConsentWithdrawal.css';
import { useState } from "react";
import { useTranslation } from "react-i18next";
const ConsentWithdrawal = () => {
  const consent_withrawal_key = process.env.REACT_APP_CONSENT_WITHDRAWAL_URL;
  const [showIframe, setShowIframe] = useState(false);
  const { t, i18n } = useTranslation();
  const [urlLocale, setUrlLocale] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const locale = params.get('locale');
    setUrlLocale(locale)

    if (locale === 'en' || locale === 'sv') {
      i18n.changeLanguage(locale);
    } else {
      i18n.changeLanguage('sv');
    }
  }, []);



  return (
    <div className="main-section main-body-bg">
      <div className="term-and-condition consent-withdrawal">
        <div className="width-1200 h-100vh">
          <div className="consent-card">
            <div className="card-side-a">
              <h1 className="h1-basic01">{t("withdraw_consent_heading")}</h1>
              <p>{t("withdraw_consent_para_1")}</p>
              <p>{t("withdraw_consent_para_2")}</p>
              <p>{t("withdraw_consent_para_3")}</p>
              <p>{t("withdraw_consent_para_4")}</p>
            </div>
            <div className="card-side-b">
              <div className="text-center">
                {!showIframe && <>
                  <p className="mb-27">{t("identify_text")}</p>
                  <Link
                    onClick={() => setShowIframe(true)}
                    to="#"
                    className="contact-us-btn consent-withdrawal-btn"
                  >
                    {t("identify_button")}
                  </Link>
                </>}
                {showIframe && (
                  <iframe
                    src={urlLocale ? `${consent_withrawal_key}${urlLocale}` : consent_withrawal_key}
                    width="100%"
                    height="600"
                    style={{ border: 'none' }}
                    title="BankID authentication"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsentWithdrawal;